import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="Asset 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={234.923}
      height={220}
      viewBox="0 0 234.923 234.371"
      {...props}
    >
      <defs>
        <linearGradient
          id="prefix__a"
          x1={0.828}
          y1={0.249}
          x2={-0.211}
          y2={1.591}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#e38ddd" />
          <stop offset={1} stopColor="#9571f6" />
        </linearGradient>
        <linearGradient
          id="prefix__b"
          x1={1.297}
          y1={-0.163}
          x2={0.773}
          y2={0.331}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#aa80f9" />
          <stop offset={1} stopColor="#6165d7" />
        </linearGradient>
        <linearGradient
          id="prefix__c"
          x1={1.185}
          y1={-0.125}
          x2={0.086}
          y2={0.912}
          xlinkHref="#prefix__a"
        />
        <linearGradient
          id="prefix__k"
          x1={6.627}
          y1={-0.163}
          x2={6.103}
          y2={0.331}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__d"
          x1={0.414}
          y1={1.865}
          x2={0.792}
          y2={-3.746}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#f36f56" />
          <stop offset={1} stopColor="#ffc444" />
        </linearGradient>
        <linearGradient
          id="prefix__m"
          x1={0.226}
          y1={4.617}
          x2={0.607}
          y2={-0.992}
          xlinkHref="#prefix__d"
        />
        <linearGradient
          id="prefix__h"
          x1={0.018}
          y1={0.485}
          x2={1.023}
          y2={0.485}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ff9085" />
          <stop offset={1} stopColor="#fb6fbb" />
        </linearGradient>
        <linearGradient
          id="prefix__n"
          x1={-1.22}
          y1={8.335}
          x2={0.421}
          y2={0.822}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__e"
          x1={31.744}
          y1={-29.094}
          x2={31.952}
          y2={-23.43}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ab316d" />
          <stop offset={1} stopColor="#792d3d" />
        </linearGradient>
        <linearGradient
          id="prefix__f"
          x1={29.879}
          y1={-26.482}
          x2={29.774}
          y2={-34.128}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#ffc444" />
          <stop offset={1} stopColor="#f36f56" />
        </linearGradient>
        <linearGradient
          id="prefix__o"
          x1={0.615}
          y1={-10.636}
          x2={0.822}
          y2={-4.974}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__p"
          x1={28.082}
          y1={-1.914}
          x2={27.931}
          y2={-6.066}
          xlinkHref="#prefix__f"
        />
        <linearGradient
          id="prefix__g"
          x1={1.177}
          y1={0.979}
          x2={0.37}
          y2={0.272}
          gradientUnits="objectBoundingBox"
        >
          <stop offset={0} stopColor="#444b8c" />
          <stop offset={1} stopColor="#26264f" />
        </linearGradient>
        <linearGradient
          id="prefix__q"
          x1={1.577}
          y1={0.989}
          x2={0.339}
          y2={0.283}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__r"
          x1={0.73}
          y1={0.887}
          x2={0.403}
          y2={0.09}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__s"
          x1={-0.471}
          y1={1.243}
          x2={0.756}
          y2={0.193}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__t"
          x1={-0.071}
          y1={3.077}
          x2={0.656}
          y2={0.231}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__u"
          x1={-0.26}
          y1={6.844}
          x2={0.49}
          y2={0.312}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__v"
          x1={0.148}
          y1={2.38}
          x2={-0.318}
          y2={-0.386}
          xlinkHref="#prefix__f"
        />
        <linearGradient
          id="prefix__w"
          x1={-0.987}
          y1={0.07}
          x2={-5.718}
          y2={3.553}
          xlinkHref="#prefix__f"
        />
        <linearGradient
          id="prefix__x"
          x1={0.637}
          y1={-0.549}
          x2={0.12}
          y2={3.256}
          xlinkHref="#prefix__f"
        />
        <linearGradient
          id="prefix__y"
          x1={0}
          y1={0.5}
          x2={1}
          y2={0.5}
          xlinkHref="#prefix__b"
        />
        <linearGradient
          id="prefix__z"
          x1={30.458}
          y1={3.148}
          x2={29.971}
          y2={4.07}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__A"
          x1={87.799}
          y1={6.219}
          x2={86.326}
          y2={8.143}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__B"
          x1={-3.501}
          y1={6.217}
          x2={-2.788}
          y2={6.94}
          xlinkHref="#prefix__f"
        />
        <linearGradient
          id="prefix__C"
          x1={-11.744}
          y1={-7.591}
          x2={-12.775}
          y2={-5.939}
          xlinkHref="#prefix__g"
        />
        <linearGradient
          id="prefix__D"
          x1={-18.344}
          y1={-7.611}
          x2={-17.895}
          y2={-7.611}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__E"
          x1={-0.109}
          y1={0.34}
          x2={0.094}
          y2={0.428}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__F"
          x1={-0.248}
          y1={0.127}
          x2={0.49}
          y2={0.614}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__G"
          x1={-0.553}
          y1={0.1}
          x2={0.458}
          y2={0.587}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__H"
          x1={0.214}
          y1={0.323}
          x2={0.931}
          y2={0.953}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__I"
          x1={0.364}
          y1={-0.088}
          x2={0.54}
          y2={1.094}
          xlinkHref="#prefix__e"
        />
        <linearGradient
          id="prefix__J"
          x1={0.113}
          y1={0.311}
          x2={0.932}
          y2={0.944}
          xlinkHref="#prefix__h"
        />
        <linearGradient
          id="prefix__K"
          x1={-0.174}
          y1={0.249}
          x2={0.027}
          y2={0.324}
          xlinkHref="#prefix__e"
        />
        <clipPath id="prefix__i">
          <path
            data-name="Path 3505"
            d="M1939.125 958.735c-4.26-7.264-.127-19.363 4.934-26.445 5.908-8.269 10.708-6.384 14.8-13.172 7.622-12.64-5.89-24.361.786-37.717 5.459-10.919 16.561-7.229 22.055-19.6 3.964-8.923.09-15.134 6.1-21.764.513-.564 6.142-6.6 12.979-5.507 6.9 1.1 11 8.819 12.334 14.148 2.476 9.849-4.092 13-5.442 25.757-1.837 17.361 9.251 21.789 5.256 34.293-3.3 10.325-11.62 9.688-15.05 21.209-3.186 10.7 2.833 15.136 0 22.13-6.514 16.09-50.063 21.487-58.752 6.668z"
            transform="translate(-1937.355 -834.403)"
            fill="url(#prefix__a)"
          />
        </clipPath>
        <clipPath id="prefix__j">
          <path
            data-name="Path 3514"
            d="M1891.85 201.413c-8.766-3.729-13.31-14.606-13.6-23.237-.448-13.319 9.427-15.47 10.615-29.783 1.262-15.22-9.443-18.362-7.634-32.793 1.658-13.219 10.862-12.37 14.906-27.949 4.066-15.665-3.65-22.117 2.849-34.831 1.24-2.424 6.333-12.391 15.261-13.046 7.469-.549 14.217 5.67 17.05 11.608 3.2 6.715.053 10.253.362 22.129.423 16.224 6.476 16.4 5.376 27.417-1.469 14.727-12.415 17.8-11.092 29.587.886 7.929 6.434 7.945 9.668 17.235 4.624 13.274-1.047 29.462-10.12 39.671-1.191 1.339-18.561 20.41-33.641 13.992z"
            transform="translate(-1878.237 -39.74)"
            fill="url(#prefix__b)"
          />
        </clipPath>
        <clipPath id="prefix__l">
          <path
            data-name="Path 3523"
            d="M542.81 450.077c8.766-3.731 13.308-14.608 13.6-23.237.448-13.319-9.427-15.47-10.615-29.783-1.262-15.221 9.443-18.362 7.633-32.793-1.657-13.22-10.861-12.371-14.906-27.949-4.066-15.666 3.65-22.116-2.849-34.831-1.241-2.428-6.335-12.391-15.261-13.05-7.47-.549-14.219 5.671-17.051 11.609-3.2 6.714-.054 10.253-.363 22.129-.422 16.223-6.476 16.4-5.377 27.417 1.469 14.727 12.416 17.8 11.092 29.587-.89 7.929-6.435 7.945-9.669 17.234-4.622 13.274 1.047 29.463 10.122 39.672 1.19 1.339 18.561 20.41 33.644 13.995z"
            transform="translate(-497.399 -288.399)"
            fill="url(#prefix__c)"
          />
        </clipPath>
      </defs>
      <g data-name="Layer 2">
        <path
          data-name="Path 3498"
          d="M122.31.051C62.799-1.669 11.251 40.573 3.465 95.999c-8.517 60.6 38.353 115.127 96.016 123.86 71.727 10.863 141.3-51.979 135.051-120.153C229.825 48.344 182.801 1.799 122.31.051z"
          fill="none"
        />
        <path
          data-name="Path 3499"
          d="M1939.125 958.735c-4.26-7.264-.127-19.363 4.934-26.445 5.908-8.269 10.708-6.384 14.8-13.172 7.622-12.64-5.89-24.361.786-37.717 5.459-10.919 16.561-7.229 22.055-19.6 3.964-8.923.09-15.134 6.1-21.764.513-.564 6.142-6.6 12.979-5.507 6.9 1.1 11 8.819 12.334 14.148 2.476 9.849-4.092 13-5.442 25.757-1.837 17.361 9.251 21.789 5.256 34.293-3.3 10.325-11.62 9.688-15.05 21.209-3.186 10.7 2.833 15.136 0 22.13-6.514 16.09-50.063 21.487-58.752 6.668z"
          transform="translate(-1781.256 -767.173)"
          fill="url(#prefix__a)"
        />
        <g
          data-name="Group 263"
          transform="translate(156.099 67.23)"
          clipPath="url(#prefix__i)"
          fill="#fff"
        >
          <path
            data-name="Path 3500"
            d="M7.54 135.778a.146.146 0 01-.016-.291 49.636 49.636 0 0020.519-6.819c5.893-3.545 11.988-7.21 14.692-13.956 2.044-5.1.919-8.863-.507-13.617a44.193 44.193 0 01-2.164-19.234c.546-5.038 1.224-11.307 5.591-17.243a21.715 21.715 0 017.191-6.244c2.275-1.37 4.074-2.444 5.124-5.328 1.712-4.709.587-8.761-.716-13.456a50.607 50.607 0 01-1.953-9.46c-.887-10.024 3.843-20.8 14.063-32.034a.147.147 0 01.216.2C59.416 9.466 54.709 20.169 55.591 30.109a50.5 50.5 0 001.944 9.409c1.316 4.739 2.452 8.833.708 13.63-1.084 2.981-3.013 4.138-5.248 5.479a21.449 21.449 0 00-7.106 6.167c-4.321 5.871-5 12.1-5.535 17.1-.948 8.765.772 14.5 2.152 19.12 1.442 4.813 2.579 8.615.5 13.809-2.74 6.837-8.878 10.528-14.813 14.1a49.93 49.93 0 01-20.637 6.859z"
            opacity={0.7}
          />
          <path
            data-name="Path 3501"
            d="M43.919 67.773a.145.145 0 01-.134-.087c-5.967-13.507-6.9-23.964-6.64-30.358.287-6.94 2.015-10.737 2.032-10.775a.146.146 0 11.264.123c-.017.037-1.724 3.8-2.006 10.685-.26 6.359.677 16.763 6.616 30.208a.14.14 0 010 .112.146.146 0 01-.078.081.168.168 0 01-.054.011z"
            opacity={0.7}
          />
          <path
            data-name="Path 3502"
            d="M39.984 89.2a.146.146 0 01-.037-.286c17.14-4.549 25.577-14.458 29.637-21.97a39.643 39.643 0 004.754-15.353.147.147 0 01.146-.14h.007a.146.146 0 01.139.151 39.862 39.862 0 01-4.786 15.48c-4.087 7.563-12.578 17.536-29.819 22.112a.139.139 0 01-.041.006z"
            opacity={0.7}
          />
          <path
            data-name="Path 3503"
            d="M34.667 125.14a.146.146 0 01-.094-.036c-12.829-11.046-16.971-22.447-18.187-30.061a33.889 33.889 0 01.443-14.044.147.147 0 11.28.087 33.565 33.565 0 00-.432 13.927c1.208 7.564 5.332 18.887 18.086 29.872a.146.146 0 01-.1.256z"
            opacity={0.7}
          />
          <path
            data-name="Path 3504"
            d="M55.631 28.547a.145.145 0 01-.134-.2.144.144 0 01.08-.079c12.4-5.247 17.678-14.187 19.921-20.764a35.432 35.432 0 001.919-13.162.147.147 0 01.059-.138.146.146 0 01.232.112 35.732 35.732 0 01-1.933 13.272c-2.262 6.637-7.583 15.659-20.089 20.949a.142.142 0 01-.055.01z"
            opacity={0.7}
          />
        </g>
        <path
          data-name="Path 3506"
          d="M1891.85 201.413c-8.766-3.729-13.31-14.606-13.6-23.237-.448-13.319 9.427-15.47 10.615-29.783 1.262-15.22-9.443-18.362-7.634-32.793 1.658-13.219 10.862-12.37 14.906-27.949 4.066-15.665-3.65-22.117 2.849-34.831 1.24-2.424 6.333-12.391 15.261-13.046 7.469-.549 14.217 5.67 17.05 11.608 3.2 6.715.053 10.253.362 22.129.423 16.224 6.476 16.4 5.376 27.417-1.469 14.727-12.415 17.8-11.092 29.587.886 7.929 6.434 7.945 9.668 17.235 4.624 13.274-1.047 29.462-10.12 39.671-1.191 1.339-18.561 20.41-33.641 13.992z"
          transform="translate(-1726.902 -36.538)"
          fill="url(#prefix__b)"
        />
        <path
          data-name="Path 3507"
          d="M1891.85 201.413c-8.766-3.729-13.31-14.606-13.6-23.237-.448-13.319 9.427-15.47 10.615-29.783 1.262-15.22-9.443-18.362-7.634-32.793 1.658-13.219 10.862-12.37 14.906-27.949 4.066-15.665-3.65-22.117 2.849-34.831 1.24-2.424 6.333-12.391 15.261-13.046 7.469-.549 14.217 5.67 17.05 11.608 3.2 6.715.053 10.253.362 22.129.423 16.224 6.476 16.4 5.376 27.417-1.469 14.727-12.415 17.8-11.092 29.587.886 7.929 6.434 7.945 9.668 17.235 4.624 13.274-1.047 29.462-10.12 39.671-1.191 1.339-18.561 20.41-33.641 13.992z"
          transform="translate(-1726.902 -36.538)"
          fill="url(#prefix__b)"
        />
        <g
          data-name="Group 264"
          transform="translate(151.335 3.202)"
          clipPath="url(#prefix__j)"
          fill="#fff"
        >
          <path
            data-name="Path 3508"
            d="M18.798 166.348a.146.146 0 01-.107-.246c9.933-10.583 14.816-21.256 14.513-31.722-.143-4.954-1.406-7.909-2.866-11.33a54.188 54.188 0 01-4.251-14.237c-2.2-13.612-1.066-25.945 3.379-36.646a41.1 41.1 0 016.974-11.423c2.3-2.81 4.109-5.029 4.834-9.97.847-5.761-.746-9.6-2.589-14.044a44.623 44.623 0 01-3.875-14.191 63.811 63.811 0 014.328-28.362.146.146 0 01.076-.081.145.145 0 01.112 0 .146.146 0 01.084.188 63.494 63.494 0 00-4.309 28.234 44.37 44.37 0 003.853 14.105c1.861 4.485 3.465 8.358 2.609 14.2-.739 5.021-2.578 7.267-4.9 10.111a40.9 40.9 0 00-6.929 11.35c-4.425 10.654-5.555 22.931-3.362 36.488a53.966 53.966 0 004.231 14.17c1.473 3.448 2.745 6.427 2.891 11.437.3 10.545-4.6 21.287-14.593 31.93a.142.142 0 01-.103.039z"
            opacity={0.7}
          />
          <path
            data-name="Path 3509"
            d="M41.132 42.854a.149.149 0 01-.063-.014c-10.4-4.943-16.721-14.652-20.191-21.926a67.959 67.959 0 01-5.084-14.745.146.146 0 11.286-.054 67.7 67.7 0 005.065 14.679c3.448 7.229 9.726 16.876 20.05 21.781a.146.146 0 01-.062.277z"
            opacity={0.7}
          />
          <path
            data-name="Path 3510"
            d="M28.686 74.727a.146.146 0 010-.291c14.013-.53 21.557-9.126 25.418-16.242a47.358 47.358 0 005.077-15.5.146.146 0 01.084-.126.146.146 0 01.205.158 47.793 47.793 0 01-5.112 15.606c-3.9 7.187-11.514 15.866-25.664 16.4z"
            opacity={0.7}
          />
          <path
            data-name="Path 3511"
            d="M24.989 90.658a.147.147 0 01-.058-.012C12.936 85.453 8.487 76.372 6.866 69.668a35.816 35.816 0 01-.645-13.434.145.145 0 01.263-.056.143.143 0 01.023.109 35.686 35.686 0 00.645 13.324c1.607 6.635 6.015 15.625 17.9 20.768a.146.146 0 01-.058.279z"
            opacity={0.7}
          />
          <path
            data-name="Path 3512"
            d="M32.925 130.412a.146.146 0 01-.027-.288c12.706-2.417 19.4-11.067 22.778-17.9a45.924 45.924 0 004.337-14.417.152.152 0 01.161-.132.146.146 0 01.1.053.144.144 0 01.032.108 46.258 46.258 0 01-4.362 14.512c-3.407 6.893-10.162 15.623-22.988 18.063z"
            opacity={0.7}
          />
          <path
            data-name="Path 3513"
            d="M28.302 153.619h-.021c-11.448-1.654-17.827-10.375-21.162-17.4a54.892 54.892 0 01-4.537-14.976.146.146 0 11.289-.036 54.62 54.62 0 004.512 14.894c3.3 6.958 9.621 15.6 20.938 17.231a.146.146 0 01-.02.29z"
            opacity={0.7}
          />
        </g>
        <path
          data-name="Path 3515"
          d="M542.81 450.077c8.766-3.731 13.308-14.608 13.6-23.237.448-13.319-9.427-15.47-10.615-29.783-1.262-15.221 9.443-18.362 7.633-32.793-1.657-13.22-10.861-12.371-14.906-27.949-4.066-15.666 3.65-22.116-2.849-34.831-1.241-2.428-6.335-12.391-15.261-13.05-7.47-.549-14.219 5.671-17.051 11.609-3.2 6.714-.054 10.253-.363 22.129-.422 16.223-6.476 16.4-5.377 27.417 1.469 14.727 12.416 17.8 11.092 29.587-.89 7.929-6.435 7.945-9.669 17.234-4.622 13.274 1.047 29.463 10.122 39.672 1.19 1.339 18.561 20.41 33.644 13.995z"
          transform="translate(-457.321 -265.162)"
          fill="url(#prefix__k)"
        />
        <path
          data-name="Path 3516"
          d="M542.81 450.077c8.766-3.731 13.308-14.608 13.6-23.237.448-13.319-9.427-15.47-10.615-29.783-1.262-15.221 9.443-18.362 7.633-32.793-1.657-13.22-10.861-12.371-14.906-27.949-4.066-15.666 3.65-22.116-2.849-34.831-1.241-2.428-6.335-12.391-15.261-13.05-7.47-.549-14.219 5.671-17.051 11.609-3.2 6.714-.054 10.253-.363 22.129-.422 16.223-6.476 16.4-5.377 27.417 1.469 14.727 12.416 17.8 11.092 29.587-.89 7.929-6.435 7.945-9.669 17.234-4.622 13.274 1.047 29.463 10.122 39.672 1.19 1.339 18.561 20.41 33.644 13.995z"
          transform="translate(-457.321 -265.162)"
          fill="url(#prefix__c)"
        />
        <g
          data-name="Group 265"
          transform="translate(40.077 23.237)"
          clipPath="url(#prefix__l)"
          fill="#fff"
        >
          <path
            data-name="Path 3517"
            d="M40.224 166.352a.146.146 0 01-.106-.047c-9.987-10.643-14.9-21.386-14.592-31.929.145-5.01 1.417-7.989 2.89-11.441a53.943 53.943 0 004.231-14.169c2.195-13.557 1.064-25.833-3.361-36.488a40.926 40.926 0 00-6.929-11.35c-2.324-2.844-4.161-5.091-4.9-10.112-.859-5.841.748-9.713 2.609-14.2a44.408 44.408 0 003.854-14.105 63.6 63.6 0 00-4.31-28.234.146.146 0 01.273-.1 63.8 63.8 0 014.327 28.362 44.628 44.628 0 01-3.876 14.2c-1.844 4.445-3.437 8.284-2.59 14.045.725 4.941 2.541 7.16 4.834 9.969a41.158 41.158 0 016.974 11.424c4.449 10.708 5.585 23.036 3.382 36.646a54.244 54.244 0 01-4.25 14.237c-1.462 3.421-2.724 6.376-2.868 11.331-.3 10.465 4.581 21.138 14.514 31.722a.147.147 0 01-.106.242z"
            opacity={0.7}
          />
          <path
            data-name="Path 3518"
            d="M17.89 42.855a.146.146 0 01-.063-.277c10.327-4.9 16.6-14.557 20.053-21.789a67.669 67.669 0 005.061-14.672.146.146 0 11.286.055 67.975 67.975 0 01-5.084 14.745c-3.465 7.274-9.786 16.983-20.191 21.926a.139.139 0 01-.062.013z"
            opacity={0.7}
          />
          <path
            data-name="Path 3519"
            d="M30.335 74.73c-14.15-.533-21.767-9.212-25.664-16.4A47.972 47.972 0 01-.442 42.724a.147.147 0 01.129-.161.148.148 0 01.161.129 47.462 47.462 0 005.084 15.507c3.861 7.117 11.4 15.712 25.414 16.239a.146.146 0 01-.006.291z"
            opacity={0.7}
          />
          <path
            data-name="Path 3520"
            d="M34.03 90.661a.145.145 0 01-.057-.279c11.884-5.145 16.292-14.14 17.9-20.779a35.6 35.6 0 00.644-13.313.146.146 0 01.286-.052 35.945 35.945 0 01-.645 13.434c-1.62 6.7-6.07 15.785-18.065 20.977a.137.137 0 01-.063.012z"
            opacity={0.7}
          />
          <path
            data-name="Path 3521"
            d="M26.097 130.416h-.028c-12.826-2.439-19.579-11.169-22.988-18.063a46.218 46.218 0 01-4.362-14.511.146.146 0 01.132-.161.152.152 0 01.161.132 45.908 45.908 0 004.337 14.417c3.378 6.831 10.072 15.482 22.777 17.9a.146.146 0 01-.027.289z"
            opacity={0.7}
          />
          <path
            data-name="Path 3522"
            d="M30.72 153.621a.145.145 0 01-.021-.29c11.318-1.635 17.633-10.272 20.938-17.231a54.418 54.418 0 004.512-14.893.149.149 0 01.161-.127.145.145 0 01.126.161 54.884 54.884 0 01-4.536 14.977c-3.336 7.025-9.715 15.747-21.162 17.4z"
            opacity={0.7}
          />
        </g>
        <path
          data-name="Path 3524"
          d="M988.828 92.534l-44.185-50.277c-1.835-1.966-5.58-1.516-8.242-1.65a9.655 9.655 0 00-7.143 2.607l-51.62 49a18.146 18.146 0 00-5.808 13.063v137.539c0 8.73 7.6 14.987 16.712 13.849l90.912-11.337c7.77-.967 13.947-8.249 13.947-16.169V104.267a17.181 17.181 0 00-4.573-11.733zm-52.813 6.24A12.158 12.158 0 01923.768 86.7a11.952 11.952 0 0112.247-11.9 12.163 12.163 0 0112.006 12.069 11.956 11.956 0 01-12.006 11.905z"
          transform="translate(-801.584 -37.323)"
          fill="url(#prefix__d)"
        />
        <path
          data-name="Path 3525"
          d="M1054.248 94.887l-45.057-48.458a10.24 10.24 0 00-6.963-3.271 9.534 9.534 0 00-7.091 2.6l-25.368 24.2-25.707 24.617a17.959 17.959 0 00-5.612 13.017v137.026c0 8.7 7.493 14.906 16.535 13.778l66.2-8.287 23.747-2.965c7.717-.967 13.83-8.242 13.83-16.132V106.578a17.125 17.125 0 00-4.514-11.691zm-52.4-17.658a12.1 12.1 0 0111.918 12.022 11.889 11.889 0 01-11.918 11.857A12.088 12.088 0 01989.7 89.083a11.882 11.882 0 0112.147-11.854z"
          transform="translate(-862.836 -39.669)"
          fill="url(#prefix__m)"
        />
        <g data-name="Group 266">
          <path
            data-name="Path 3526"
            d="M1192.917 1116.38c-.233 15.375-9.85 23.366-20.557 23.325-11.665-.045-21.017-8.988-20.794-23.675.211-13.964 9.008-23.911 22.077-22.935 12.681.947 19.463 10.735 19.274 23.285zm-27.694-.3c-.122 8.021 2.5 13.851 7.631 13.946 4.934.092 7.4-4.937 7.522-13.352.115-7.608-1.836-13.609-7.225-13.932-5.244-.309-7.812 5.675-7.928 13.343zm10.825 49.433l37.154-67.269a3.76 3.76 0 013.571-1.934 3.76 3.76 0 013.02 5.552l-36.741 67.251a3.76 3.76 0 01-3.133 1.953l-.411.018a3.76 3.76 0 01-3.46-5.566zm63.572-18.957c-.216 14.241-8.47 22.033-17.63 22.435-9.852.432-17.8-7.423-17.7-20.957.194-12.872 7.693-22.438 18.845-22.139 10.855.297 16.665 9.042 16.485 20.666zm-23.6.934c-.213 7.406 2.02 12.675 6.4 12.547 4.22-.123 6.33-4.874 6.446-12.656.107-7.036-1.46-12.494-6.067-12.55-4.573-.051-6.669 5.587-6.777 12.664z"
            transform="translate(-1058.777 -1004.961)"
            fill="url(#prefix__h)"
            opacity={0.15}
          />
        </g>
        <path
          data-name="Path 3527"
          d="M135.935 110.708c-.233 15.376-9.85 23.366-20.557 23.325-11.666-.044-21.017-8.989-20.795-23.675.211-13.963 9.008-23.912 22.077-22.935 12.688.944 19.464 10.731 19.275 23.285zm-27.694-.295c-.122 8.021 2.5 13.85 7.63 13.945 4.935.092 7.4-4.936 7.523-13.351.115-7.609-1.836-13.609-7.226-13.933-5.243-.318-7.812 5.667-7.927 13.335zm10.825 49.432l37.154-67.269a3.758 3.758 0 013.571-1.934 3.76 3.76 0 013.02 5.551l-36.741 67.251a3.759 3.759 0 01-3.134 1.953l-.411.019a3.761 3.761 0 01-3.459-5.576zm63.572-18.957c-.216 14.237-8.471 22.031-17.63 22.434-9.852.433-17.8-7.422-17.7-20.957.194-12.87 7.694-22.438 18.845-22.138 10.854.288 16.66 9.034 16.484 20.657zm-23.6.935c-.213 7.406 2.02 12.675 6.4 12.547 4.22-.123 6.33-4.874 6.446-12.656.107-7.036-1.46-12.494-6.066-12.55-4.575-.06-6.672 5.578-6.779 12.656z"
          fill="#fff"
        />
        <path
          data-name="Path 3528"
          d="M158.3 210.439l-66.155 8.287c-9.043 1.128-16.534-5.076-16.534-13.778V67.923a17.956 17.956 0 015.61-13.017l25.756-24.619c-4.872 15.658-3.53 27.091-.811 35.157 8.605 25.531 33.707 26.884 40.2 52.71 5.241 20.852-8.534 30.345-6.693 53.378.872 10.989 5.278 24.47 18.627 38.907z"
          fill="#fff"
          opacity={0.35}
        />
        <path
          data-name="Path 3529"
          d="M827.265 1643.034l1.6-1.224c.467.132 8.138 2.437 9.655 9.186.209.928.978 4.351-.9 6.546-3.142 3.685-12.253 2.234-16.53-2.92-3.36-4.05-3.779-10.436-1.836-11.632 2.35-1.45 9.356 3.967 9.89 4.38 1.071.828 2.043 1.708 2.214 1.554.294-.262-2.007-3.27-4.093-5.89z"
          transform="translate(-752.182 -1509.524)"
          fill="url(#prefix__n)"
        />
        <path
          data-name="Path 3530"
          d="M118.728 2206.977s.409-1.061-.231-1.616a14.27 14.27 0 00-5.956-2.127c-1.777.033-.345 1.4.67 2.176a23.111 23.111 0 003.992 2.537c.612.14 1.525-.97 1.525-.97z"
          transform="translate(-102.699 -2025.712)"
          fill="url(#prefix__e)"
        />
        <path
          data-name="Path 3531"
          d="M152.226 2230.192a42.348 42.348 0 00-2.611-1.88 10.661 10.661 0 00-2.846-1.52c-.585-.183-1.912-.522-2.036-.247s1.1.936 4.123 3.228c.438.333 1.831 1.4 1.831 1.4z"
          transform="translate(-133.063 -2047.05)"
          fill="url(#prefix__f)"
        />
        <path
          data-name="Path 3532"
          d="M794.223 2851.1s-.41 1.06.23 1.616a14.252 14.252 0 005.953 2.135c1.777-.031.346-1.4-.666-2.175a23.1 23.1 0 00-3.984-2.541c-.61-.135-1.533.965-1.533.965z"
          transform="translate(-730.111 -2620.479)"
          fill="url(#prefix__o)"
        />
        <path
          data-name="Path 3533"
          d="M798.626 2804a13.006 13.006 0 00.214 3.211 4.1 4.1 0 00.857 2.256c.913.967 2.511 1.156 2.739.768.263-.441-1.429-1.3-1.989-3.369a5.363 5.363 0 01-.092-2.3z"
          transform="translate(-734.258 -2578.073)"
          fill="url(#prefix__p)"
        />
        <path
          data-name="Path 3534"
          d="M723.616 2090.638c2.394 2.52 1.871 6.123 1.122 12.575a649.454 649.454 0 00-2.292 23.559l-2.195 21.212h-3.657a34.156 34.156 0 01-3.365-14.044c-.073-4.977 1.089-5.63 1.314-11.265.123-3.1-.151-4.835-2.484-18.287-1.853-10.7-2.221-12.707-.732-14.336 2.629-2.873 9.246-2.618 12.289.586z"
          transform="translate(-653.167 -1919.814)"
          fill="url(#prefix__g)"
        />
        <path
          data-name="Path 3535"
          d="M716.307 2139.978c.629-1.973 2.3-3.989 2.417-7.9.133-4.615-2.079-5.766-1.756-10.094.312-4.159 2.458-4.461 3.073-8.559.714-4.758-1.934-6-2.852-11.629a26.911 26.911 0 011.641-13.48c-2.84-.518-5.9.067-7.493 1.81-1.489 1.629-1.128 3.637.732 14.336 2.337 13.449 2.607 15.188 2.484 18.286-.225 5.635-1.388 6.289-1.314 11.265a34.152 34.152 0 003.365 14.043h1.209c-1.955-3.556-2.122-6.145-1.506-8.078z"
          transform="translate(-653.172 -1919.887)"
          opacity={0.4}
          fill="url(#prefix__q)"
        />
        <path
          data-name="Path 3536"
          d="M191.11 2041.787c5.127 7.064 14.93 18.735 23.407 16.759 4.482-1.048 6.108-5.329 19.282-23.42a623.633 623.633 0 017.781-10.454l-15.36-3.8a112.851 112.851 0 00-7.136 13.789c-3.364 7.793-4.577 13.1-7.639 13.42-1.5.161-2.467-.978-4.535-2.633a42.251 42.251 0 00-13.166-7.022z"
          transform="translate(-175.712 -1858.042)"
          fill="url(#prefix__r)"
        />
        <path
          data-name="Path 3537"
          d="M66.947 1231.8c-1.153-1.853-2.932-2.587-4.92-3.371-2.578-1.017-3.74-.806-5.655-1.295-4.738-1.2-4.829-4.3-9.081-6.43-5.435-2.723-8.09.93-12.6-1.474-5.062-2.7-3.269-8.132-7.745-11.734-6.208-5-20.722-3.445-25.289 5.179-2.638 4.98-2.142 12.665 1.582 16.979 2.171 2.514 5.286 3.852 5.129 6.094-.11 1.6-2 1.813-3.1 4.08-1.426 2.923-.1 6.278.109 6.82 1.981 5.03 11.018 8.126 18.98 7.054 14.355-1.934 20.707-16.818 29.848-13.993 1.682.52 4.109 1.97 7.505 1.438 1.021-.161 4.639-.725 5.921-3.724 1.124-2.641-.483-5.303-.684-5.623z"
          transform="translate(.002 -1107.599)"
          fill="url(#prefix__s)"
        />
        <path
          data-name="Path 3538"
          d="M365.818 1636.865a126.762 126.762 0 0113.755.553c10.68 1.128 10.259 6.441 8.326 11.285a27.216 27.216 0 00-1.865 10.862 41.821 41.821 0 001.429 8.52c1.579 6.969 2.756 8.57 1.644 10.352-1.622 2.6-6.168 2.47-6.965 2.432-4.038-.194-4.895-2.564-8.3-2.939-3.955-.436-4.87 2.535-10.369 4.534-6.492 2.36-14.849 1.735-18.73-2.611-1.5-1.678-2.461-4-1.816-4.726.877-.993 3.93 1.865 7.178.732 2.152-.752 1.958-2.406 4.535-4.02 3.1-1.943 4.927-.513 7.03-1.767 3.281-1.956 2.578-7.661 2.84-17.052a156.522 156.522 0 011.308-16.155z"
          transform="translate(-315.109 -1504.976)"
          fill="url(#prefix__t)"
        />
        <path
          data-name="Path 3539"
          d="M245.306 1632.523c-5.7.278-7.735 6.2-13.68 7.377-3.6.709-8.977-.264-16.695-7.76l-3.282 1.519a22.288 22.288 0 005.78 12.1c8.759 9.086 25.372 8.807 34.367 1.019a21.479 21.479 0 005.278-7.031c-2.841-3.54-6.979-7.457-11.768-7.224z"
          transform="translate(-194.597 -1500.633)"
          fill="url(#prefix__u)"
        />
        <path
          data-name="Path 3540"
          d="M701.164 1581.088a.645.645 0 00-.99.328c-.373 1.153-1.144 3.116-2.195 3.606-1.512.706-3.787.4-4.078.676s6.792 3.953 11.508 2.283a.615.615 0 00.1-.043l.268-.145a.644.644 0 00-.181-1.2c-.91-.181-3.293-.865-3.893-1.9a5.533 5.533 0 01-.071-1.194l.193-1.52a.645.645 0 00-.267-.6z"
          transform="translate(-637.983 -1453.584)"
          fill="url(#prefix__v)"
        />
        <path
          data-name="Path 3541"
          d="M761.506 1554.066a2.127 2.127 0 002.271 1.016c1.345-.316.973-3.739 0-4.241a1.822 1.822 0 00-1.409.025 2.021 2.021 0 00-.9 2.182c-.315-.134-.611-.081-.7.071-.116.193.126.505.181.576a1.109 1.109 0 00.557.371z"
          transform="translate(-699.44 -1425.767)"
          fill="url(#prefix__w)"
        />
        <path
          data-name="Path 3542"
          d="M217.377 1563.472l-.537-1.059s2.744-4.488.495-5.208-1.611.564-1.359 1.174a5.738 5.738 0 01-.547 3.223c-.391.614.289 2.642.289 2.642z"
          transform="translate(-197.959 -1431.54)"
          fill="url(#prefix__x)"
        />
        <path
          data-name="Path 3543"
          d="M305.31 1798.454c1.419-.967.442-2.859 2.048-4.389 1.47-1.4 3.078-.564 5.705-1.316a11.507 11.507 0 006.729-5.706c.8-1.6.736-2.643 0-10.825-.7-7.792-.9-9.7-1.9-9.948-1.822-.459-3.453 5.265-7.022 5.266-2.014 0-2.288-1.825-4.827-2.78-4.31-1.619-7.39 2.189-12 2.048a9.133 9.133 0 01-4.236-1.259c6.638 6.4 17.331 7.8 26 4.9-.118 7.92.19 12.8-2.79 14.583-2.1 1.254-3.928-.175-7.03 1.767-2.578 1.612-2.383 3.268-4.535 4.02-3.249 1.134-6.3-1.725-7.178-.731-.584.662.157 2.625 1.417 4.238a8.021 8.021 0 012.447-.6c3.403-.265 5.497 1.871 7.172.732z"
          transform="translate(-266.459 -1623.933)"
          opacity={0.3}
          fill="url(#prefix__y)"
        />
        <path
          data-name="Path 3544"
          d="M979.623 1403.885l-.4-1.042 1.041-1.03a.748.748 0 01.875-.13 14.94 14.94 0 017.523 9.5.748.748 0 01-.318.8 10.1 10.1 0 01-1.04.581z"
          transform="translate(-900.321 -1288.666)"
          fill="url(#prefix__z)"
        />
        <path
          data-name="Path 3545"
          d="M891.581 1586.531l.619 3.411a5.834 5.834 0 00.193 1.37 2.941 2.941 0 01-1.363.757l-1.94-3.851 2.376-1.7z"
          transform="translate(-817.453 -1458.689)"
          fill="url(#prefix__A)"
        />
        <path
          data-name="Path 3546"
          d="M902.66 1614.567l-.553-1.386a2.5 2.5 0 00-1.934-1.282c-1.427-.186-1.413.584-1.413.584l.932.275a1.868 1.868 0 011.017 1.047 5.455 5.455 0 001.2 1.338z"
          transform="translate(-826.344 -1481.997)"
          fill="url(#prefix__B)"
        />
        <path
          data-name="Path 3547"
          d="M849.85 1431.43s8.669-8.3 10.425-14.35c6.165 1.7 8.081 9.722 8.081 9.722s-12.415 4.049-16.48 7.212c-1.457-.321-2.026-2.584-2.026-2.584z"
          transform="translate(-781.375 -1302.902)"
          fill="url(#prefix__C)"
        />
        <path
          data-name="Path 3548"
          d="M1016.133 1357.812a1.047 1.047 0 01-.683-.815c-1.782-10.728-9.274-12.436-9.347-12.452a1.047 1.047 0 01.435-2.049c.366.081 8.965 2.035 10.979 14.158a1.048 1.048 0 01-1.383 1.159z"
          transform="translate(-924.275 -1234.305)"
          fill="url(#prefix__D)"
        />
        <path
          data-name="Path 3549"
          d="M2232.993 1931.1a.618.618 0 01-.615-.564 32.82 32.82 0 00-5.22-15.211c-2.5-3.653-5.479-5.833-7.969-5.833h-.009c-9.064.018-10.958 20.829-10.979 21.039a.619.619 0 11-1.233-.105c.08-.9 2.018-22.151 12.209-22.172h.012c2.94 0 6.216 2.322 8.99 6.372a34.062 34.062 0 015.43 15.792.62.62 0 01-.558.675.23.23 0 01-.058.007z"
          transform="translate(-2029.143 -1754.496)"
          fill="url(#prefix__E)"
        />
        <path
          data-name="Path 3550"
          d="M2046.774 2199.74l11.932 6.043 7.23-22.189-11.913-29.744-3.379.828-5.125 42.717a2.317 2.317 0 001.255 2.345z"
          transform="translate(-1880.691 -1980.307)"
          fill="url(#prefix__F)"
        />
        <path
          data-name="Path 3551"
          d="M2128.881 2183.594l-11.913-29.744-1.993.489a64.736 64.736 0 00.034 9.619c.8 10.128 3.45 12.945 2.165 20.009-1.068 5.875-3.4 6.672-3.2 10.624.223 4.3 3.224 7.91 6.794 10.744l.881.446z"
          transform="translate(-1943.635 -1980.307)"
          opacity={0.52}
          fill="url(#prefix__G)"
        />
        <path
          data-name="Path 3552"
          d="M2151.25 2187.57h44.49l14.725 47.536-54.533 4.394z"
          transform="translate(-1977.917 -2014.027)"
          fill="url(#prefix__H)"
        />
        <path
          data-name="Path 3553"
          d="M2302.62 1937.8a.62.62 0 01-.6-.478c-.127-.539-3.05-13.276 1.072-19.528a7.183 7.183 0 014.906-3.251c10.655-1.877 17.215 21.007 17.489 21.982a.619.619 0 11-1.192.335c-.064-.228-6.521-22.786-16.082-21.1a5.909 5.909 0 00-4.087 2.713c-3.831 5.811-.93 18.437-.9 18.563a.62.62 0 01-.6.76z"
          transform="translate(-2115.504 -1760.18)"
          fill="url(#prefix__I)"
        />
        <g data-name="Group 267">
          <path
            data-name="Path 3554"
            d="M2279.639 2153.86h-22.072a5.983 5.983 0 00-1.934 3.814c-.347 6.726 15.114 8.936 16.606 18.153 1.076 6.649-5.543 14.322-11.449 17.74-6.222 3.6-10.438 1.778-14.646 5.776a13.806 13.806 0 00-3.644 6.231l51.865-4.179z"
            transform="translate(-2061.815 -1980.317)"
            fill="url(#prefix__J)"
            opacity={0.3}
          />
        </g>
        <circle
          data-name="Ellipse 132"
          cx={1.73}
          cy={1.73}
          r={1.73}
          transform="rotate(-45 306.854 -134.067)"
          fill="url(#prefix__K)"
        />
        <circle
          data-name="Ellipse 133"
          cx={1.73}
          cy={1.73}
          r={1.73}
          transform="rotate(-76.72 216.767 -41.73)"
          fill="url(#prefix__K)"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
